import * as CubeTree from '../cubeTree/index';
import Update from '../update';
import History from '../interaction/history';
import Utils from '../utils/util';

interface Info {
    keyPath: string,
    value: any
}

interface ModifyCubeTask {
    cubeId: CubeId,
    modifyInfos: Info[]
}

function modifyCube(tasks: ModifyCubeTask[]): void {
    let updateTasks: UpdateTask[] = [];

    tasks.forEach((task: ModifyCubeTask): void => {
        let updateData: FreeObjMap = {};

        task.modifyInfos.forEach((info: Info): void => {
            // 如果字段不存在隐射，直接修改cube即可
            if (!CubeTree.hasKeyPath(task.cubeId, info.keyPath)) {
                let targetCube: CubeNode = CubeTree.findByCubeId(task.cubeId);

                Utils.setMapValueByStringKey(targetCube, info.keyPath, info.value);
                return;
            }

            // 如果存在隐射，就走update流程，同时更新cube和frontCubeData
            let keyPathAlias: string = CubeTree.getKeyPathAlias(task.cubeId, info.keyPath);

            updateData[keyPathAlias] = info.value;
        });

        if (!Utils.isEmptyObj(updateData)) {
            updateTasks.push({
                updateData,
                cubeId: task.cubeId
            });
        }
    });

    let oldInfos: UpdateTask[] = Update.getCubeBeforeUpdateInfo(updateTasks);

    if (oldInfos.length) {
        History.stackIn({
            type: 'updateByApi',
            data: oldInfos
        });
    }
    Update.run(updateTasks);
}

export {
    modifyCube
};
